module.exports = __webpack_public_path__ + "img/noData.6a312714.png";